export const MODAL_TYPE_DELETE_FILE = 'MODAL_TYPE_DELETE_FILE'
export const MODAL_TYPE_DELETE_POST = 'MODAL_TYPE_DELETE_POST'
export const MODAL_TYPE_DELETE_SLIDESHOW = 'MODAL_TYPE_DELETE_SLIDESHOW'
export const MODAL_TYPE_FILE_VIEWER = 'MODAL_TYPE_FILE_VIEWER'
export const MODAL_TYPE_COLOR_PICKER = 'MODAL_TYPE_COLOR_PICKER'

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
